import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './form-select.styles.js'
import Select from 'react-select'
import AngleDownIcon from 'react-icons/lib/fa/angle-down'
import classNames from 'classnames'

class FormSelect extends Component {
  arrowRenderer() {
    const { classes } = this.props
    return <AngleDownIcon className={classes.buttonIcon} />
  }
  renderLabel(option) {
    const { classes } = this.props
    const prefix = option.prefix ? option.prefix : null
    const label = <span className={classes.label}>{option.label}</span>
    const suffix = option.suffix ? option.suffix : null
    return (
      <Fragment>
        {prefix}
        {label}
        {suffix}
      </Fragment>
    )
  }
  valueRenderer(option) {
    const { classes, valueClassName } = this.props
    return (
      <span className={classNames(classes.value, valueClassName)}>
        {this.renderLabel(option)}
      </span>
    )
  }
  optionRenderer(option, i) {
    const { classes } = this.props
    return (
      <span
        className={classNames(
          classes.option,
          {
            [classes.oddOption]: i % 2 !== 0
          },
          option.className
        )}>
        {this.renderLabel(option)}
      </span>
    )
  }
  render() {
    const {
      classes,
      value,
      options,
      selectProps,
      className,
      onChange,
      ...props
    } = this.props
    return (
      <Select
        className={classNames(classes.select, className)}
        name="form-field-name"
        value={value}
        arrowRenderer={() => this.arrowRenderer()}
        optionRenderer={(option, i) => this.optionRenderer(option, i)}
        valueRenderer={option => this.valueRenderer(option)}
        searchable={false}
        clearable={false}
        onChange={onChange}
        options={options}
        {...selectProps}
        {...props}
      />
    )
  }
}

export default injectSheet(styles)(FormSelect)
